
import Vue from "vue";
import AppTickets from "@/views/tickets/TheTickets.vue";

export default Vue.extend({
	components: {
		AppTickets
	}
});
